import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import ChatRoom from './../../components/templates/chat/index.vue'; //Your Chat
import PostsCo from './../../components/mixins/postsco/index.vue';

let service = new services();

export default {
    name: 'Buypoint',
    mixins: [PostsCo],
    data () {
        return {
            child_route_view:false,
            loading:false,
            loggedIn:false,
            user: {},
            data_ref_link:"",
            ref_bash_details:{},
            set_shop_together:false,
            shop_together_data: {},
            shop_together_join:false,
            active_shop_together:{},
            menu_view:{},
            menu_tab_view:{},
            menu_tab_inner_view:{},
            group:{},
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'component-chatroom': ChatRoom,
        // 'component-postsco': PostsCo
     },
    methods: {
        setMenuTabView(view,attr1,attr2){
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },

        preset() {
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.loggedIn = true;
                    self.loading = false;
                    self.getShopTogetherActivities()
                }else {
                    self.$router.push('login');
                }
            });
        },
        
        setReferralBash(){
            let set_ref_for = this.user.user_id; //default
            
            var payload = {
                ref_user: this.user.user_id,
                ref_of_type: 45,//shop-together-ref-link
                ref_of: 0,
                ref_for: 0,
            }
            service.setReferralBash(this, payload).then(response => {
                // if(response.body.status == 200) {
                let data_ref_bash = response.body.data_ref_bash;
                if(data_ref_bash && (data_ref_bash != "")){
                    this.data_ref_link = service.app_url+"/shoptogether"+"/"+data_ref_bash;
                    //call set  shop-together-activity
                    this.setShopTogetherActivity(response.body.data_ref_bash_no);
                }
                //}
            }).catch((err) => {})
        },

        getReferralBashDetails(){
            service.getReferralBashDetails(this, this.$route.params.ref).then(response => {
                if(response.body.status == 200) {
                    this.ref_bash_details = response.body.data;
                    this.shop_together_join = true;
                }
            }).catch((err) => {})
        },

        getShopTogetherActivities(){
            var payload = {
                activity_user: this.user.user_id,
                activity_type: 45,//shop-together
                // activity_action_type: 46,//shop-together
                // activity_module: 34, //referral-bash
                // activity_module_id:data_ref_bash
            }
            service.getActivities(this,payload).then(response => {
                if(response.body.status == 200) {
                    this.shop_together_data = response.body.data;
                    this.setActiveShopTogetherActivities();
                }
            }).catch((err) => {})
        },

        setActiveShopTogetherActivities(){
            if(this.shop_together_data.length > 0){
                localStorage.setItem("active_shop_together_alert",1)
            }else{
                localStorage.removeItem("active_shop_together_alert");
            }
            //dump at localforage
            let self = this;
            localforage.setItem(service.s2gdb_name, self.shop_together_data).then(function (value) {}).catch(function(err) {});
        },

        setShopTogetherActivity(data_id){
            if((data_id > 0) || (data_id != undefined)){
                var payload = {
                    activity_user: this.user.user_id,
                    activity_type: 45,//shop-together
                    activity_action_type: 46,//create-shop-together
                    activity_module: 34, //referral-bash
                    activity_module_id:data_id
                }
                service.setActivity(this, payload).then(response => {
                    if((response.body.status == 201) || (response.body.status == 409)) {
                        this.set_shop_together = true;

                        //create new user group for chat purposes
                        let group = {
                            group_name: "Shop together with "+this.user.user_name,
                            group_description: "Activity Shop together with "+this.user.user_name,
                            group_module: 35, //Activities
                            group_module_id: response.body.data_activity,
                        } 
                        this.postsco_callCreateNewGroup(group);
                        //../create new ..
                    }
                }).catch((err) => {})
            }
        },

        setShopTogetherJoinIn(){
            let data_ref_bash = this.$route.params.ref;
            if((data_ref_bash != '') || (data_ref_bash != undefined)){
                var payload = {
                    activity_user: this.user.user_id,
                    activity_type: 45,//shop-together
                    activity_action_type: 47,//join
                    activity_module: 34, //referral-bash
                    activity_ref_bash:data_ref_bash, //the ref bash
                }
                service.setActivity(this, payload).then(response => {
                    if((response.body.status == 200) || (response.body.status == 201) || (response.body.status == 409)) {
                        this.set_shop_together = true;
                        //add to chat group
                        let members_arr = []; //to hold members array
                        let member = {
                            member_group: 0,
                            member_group_module: 35, 
                            member_group_module_id:response.body.data_activity || 0,
                            member_type: 3,//users
                            member_module: 1,//users
                            member_id: this.user.user_id,
                        } 
                        members_arr.push(member);
                        this.postsco_callAddNewGroupMembers(members_arr);
                        //../add
                    }
                }).catch((err) => {})
            }
        },

        setActiveShopTogetherStatus(activity,status){
            var payload = {
                activity: activity,
                activity_type: status,
            }
            service.updateActivity(this,payload).then(response => {
                if(response.body.status == 200) {
                   // this.shop_together_data = response.body.data;
                }
            }).catch((err) => {})
        },
    },

    created: function(){
        // PostsCo;
        this.preset();
        if(this.$route.params.ref){
            this.getReferralBashDetails();
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/Buypoint/script.js